"use strict";

var _typeof = require("/app/scripts/smweb-scripts/node_modules/@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bool = exports.String = exports.Number = exports.Empty = exports.Null = exports.Constant = exports.Identifier = exports.List = exports.BinOp = exports.UnaryOp = exports.BoolOp = exports.Call = exports.Attribute = exports.Expression = exports.Node = exports.Op = void 0;

var _utils = require("./utils");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var Op = /*#__PURE__*/function () {
  function Op(name, symbol, precedence // eslint-disable-next-line no-empty-function
  ) {
    _classCallCheck(this, Op);

    this.name = name;
    this.symbol = symbol;
    this.precedence = precedence;
  }

  _createClass(Op, [{
    key: "toString",
    value: function toString() {
      return this.symbol.toUpperCase();
    }
  }, {
    key: "toRepr",
    value: function toRepr() {
      return "".concat(this.name, "()");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.name.toLowerCase();
    }
  }], [{
    key: "create",
    value: function create(name, symbol, precedence) {
      var op = new Op(name, symbol, precedence);
      this.ops[name.toLowerCase()] = op;
      return op;
    }
  }]);

  return Op;
}();

exports.Op = Op;
Op.ops = {};
Op.Or = Op.create('Or', 'or', 10);
Op.And = Op.create('And', 'and', 20);
Op.Not = Op.create('Not', 'not', 30);
Op.Eq = Op.create('Eq', '=', 40);
Op.Ne = Op.create('Ne', '!=', 40);
Op.Gt = Op.create('Gt', '>', 40);
Op.Lt = Op.create('Lt', '<', 40);
Op.Ge = Op.create('Ge', '>=', 40);
Op.Le = Op.create('Le', '<=', 40);
Op.In = Op.create('In', 'in', 40);
Op.NotIn = Op.create('NotIn', 'not in', 40);
Op.Is = Op.create('Is', 'is', 40);
Op.IsNot = Op.create('IsNot', 'is not', 40);
Op.Ct = Op.create('Ct', '~', 40);
Op.NotCt = Op.create('NotCt', '!~', 40);
Op.Add = Op.create('Add', '+', 50);
Op.Sub = Op.create('Sub', '-', 50);
Op.Mul = Op.create('Mul', '*', 60);
Op.Div = Op.create('Div', '/', 60);

var Node = /*#__PURE__*/function () {
  function Node() {
    _classCallCheck(this, Node);
  }

  _createClass(Node, [{
    key: "toString",
    value: // TODO: this is VERY MUCH NOT safe, we'll need to refactor into a safer way to work
    function toString() {
      return this.toRepr();
    }
  }, {
    key: "toRepr",
    value: function toRepr() {
      var _this = this;

      var ctr = this.constructor;
      var attrs = ctr.attrs.map(function (attr) {
        return "".concat(attr, "=").concat((0, _utils.toRepr)(_this[attr]));
      });
      return "".concat(ctr.type, "(").concat(attrs.join(', '), ")");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this2 = this;

      var ctr = this.constructor;
      var result = {
        type: ctr.type.toLowerCase()
      };
      ctr.attrs.forEach(function (attr) {
        result[attr] = _this2[attr];
      });
      return result;
    }
  }], [{
    key: "load",
    value: function load(info) {
      var _this3 = this;

      if (info instanceof Array) {
        return new List(info.map(function (item) {
          return _this3.load(item);
        }));
      }

      if (info === null || info === undefined) {
        return new Null();
      }

      if (typeof info === 'boolean') {
        return new Bool(info);
      }

      if (typeof info === 'string') {
        // eslint-disable-next-line no-new-wrappers
        return new String(info);
      }

      if (typeof info === 'number') {
        // eslint-disable-next-line no-new-wrappers
        return new Number(info);
      }

      var op = info.op;
      var type = info.type;

      if (type === 'and' || type === 'or') {
        op = type;
      }

      if (info.call || info.func) {
        var _info$args;

        var infoArgs = (_info$args = info.args) !== null && _info$args !== void 0 ? _info$args : [];

        var _args = infoArgs.map(function (arg) {
          return _this3.load(arg);
        });

        if (info.call) {
          return new Call(new Identifier(info.call), _args);
        } // TODO: narrow down type of func
        // @ts-ignore


        return new Call(this.load(info.func), _args);
      }

      if (op === 'and' || op === 'or') {
        var _operands = [];

        if (info.operands) {
          _operands = info.operands;
        } else if (info.items) {
          _operands = info.items;
        }

        var items = _operands.map(function (x) {
          return _this3.load(x);
        });

        op = Op.ops[op]; // TODO: narrow down type of op
        // @ts-ignore

        var node = new BoolOp(op, items);

        if (info.negated) {
          return new UnaryOp(Op.Not, node);
        }

        return node;
      }

      if (op === 'not' && info.operand) {
        return new UnaryOp(Op.Not, this.load(info.operand));
      }

      if (op && info.left && info.right && typeof op === 'string' && Op.ops[op]) {
        return new BinOp(this.load(info.left), Op.ops[op], this.load(info.right));
      }

      if ((type === 'predicate' || info.predicate) && this.types.predicate) {
        if (!!info.variable === false || !!info.predicate === false) {
          throw new Error("".concat(info));
        } // eslint-disable-next-line new-cap


        return new this.types.predicate(info.variable, info.predicate, info.value);
      }

      if (type === 'identifier' && info.id) {
        return new Identifier(info.id);
      }

      if (type === 'attribute' && info.attr && info.value) {
        return new Attribute(this.load(info.value), info.attr);
      }

      if (type && type in this.types && this.types[type].create) {
        return this.types[type].create(info);
      }

      throw new Error("".concat(info));
    }
  }, {
    key: "register",
    value: function register(name, type) {
      // eslint-disable-next-line no-param-reassign
      type.type = name;
      this.types[name.toLowerCase()] = type;
      this.types[name] = this.types[name.toLowerCase()];
      return this.types[name];
    }
  }]);

  return Node;
}();

exports.Node = Node;
Node.attrs = [];
Node.types = {};
Node.type = 'Node';

var Expression = /*#__PURE__*/function (_Node) {
  _inherits(Expression, _Node);

  var _super = _createSuper(Expression);

  function Expression() {
    _classCallCheck(this, Expression);

    return _super.apply(this, arguments);
  }

  return Expression;
}(Node);

exports.Expression = Expression;
Expression.type = 'Expression';

var Predicate = /*#__PURE__*/function (_Expression) {
  _inherits(Predicate, _Expression);

  var _super2 = _createSuper(Predicate);

  function Predicate(variable, predicate, value) {
    var _this4;

    _classCallCheck(this, Predicate);

    _this4 = _super2.call(this);
    _this4.variable = variable;
    _this4.predicate = predicate;
    _this4.value = value;
    return _this4;
  }

  return Predicate;
}(Expression);

Predicate.attrs = ['variable', 'predicate', 'value'];

var Attribute = /*#__PURE__*/function (_Expression2) {
  _inherits(Attribute, _Expression2);

  var _super3 = _createSuper(Attribute);

  function Attribute(value, attr) {
    var _this5;

    _classCallCheck(this, Attribute);

    _this5 = _super3.call(this);
    _this5.value = value;
    _this5.attr = attr;
    return _this5;
  }

  _createClass(Attribute, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.value, ".").concat(this.attr);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        type: 'attribute',
        value: this.value.toJSON(),
        attr: this.attr
      };
    }
  }]);

  return Attribute;
}(Expression);

exports.Attribute = Attribute;
Attribute.attrs = ['value', 'attr'];

var Call = /*#__PURE__*/function (_Expression3) {
  _inherits(Call, _Expression3);

  var _super4 = _createSuper(Call);

  function Call(func, args) {
    var _this6;

    _classCallCheck(this, Call);

    _this6 = _super4.call(this);
    _this6.func = func;
    _this6.args = args;
    return _this6;
  }

  _createClass(Call, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.func, "(").concat(this.args.join(', '), ")");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var result = {};

      if (this.func instanceof Identifier) {
        result.call = this.func.id;
      } else {
        result.func = this.func.toJSON();
      }

      if (this.args.length > 0) {
        result.args = this.args.map(function (arg) {
          return arg.toJSON();
        });
      }

      return result;
    }
  }]);

  return Call;
}(Expression);

exports.Call = Call;
Call.attrs = ['func', 'args'];

var BoolOp = /*#__PURE__*/function (_Expression4) {
  _inherits(BoolOp, _Expression4);

  var _super5 = _createSuper(BoolOp);

  function BoolOp(op, operands) {
    var _this7;

    _classCallCheck(this, BoolOp);

    _this7 = _super5.call(this);
    _this7.op = op;
    _this7.operands = operands;
    return _this7;
  }

  _createClass(BoolOp, [{
    key: "toString",
    value: function toString() {
      var _this8 = this;

      return this.operands.map(function (op) {
        return (0, _utils.maybeParen)(_this8, op);
      }).join(" ".concat(this.op, " "));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        op: this.op.toJSON(),
        operands: this.operands.map(function (item) {
          return item.toJSON();
        })
      };
    }
  }]);

  return BoolOp;
}(Expression);

exports.BoolOp = BoolOp;
BoolOp.attrs = ['op', 'operands'];

var UnaryOp = /*#__PURE__*/function (_Expression5) {
  _inherits(UnaryOp, _Expression5);

  var _super6 = _createSuper(UnaryOp);

  function UnaryOp(op, operand) {
    var _this9;

    _classCallCheck(this, UnaryOp);

    _this9 = _super6.call(this);
    _this9.op = op;
    _this9.operand = operand;
    return _this9;
  }

  _createClass(UnaryOp, [{
    key: "toString",
    value: function toString() {
      return "".concat(this.op, " ").concat((0, _utils.maybeParen)(this, this.operand));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        op: this.op.toJSON(),
        operand: this.operand.toJSON()
      };
    }
  }]);

  return UnaryOp;
}(Expression);

exports.UnaryOp = UnaryOp;
UnaryOp.attrs = ['op', 'operand'];

var BinOp = /*#__PURE__*/function (_Expression6) {
  _inherits(BinOp, _Expression6);

  var _super7 = _createSuper(BinOp);

  function BinOp(left, op, right) {
    var _this10;

    _classCallCheck(this, BinOp);

    _this10 = _super7.call(this);
    _this10.left = left;
    _this10.op = op;
    _this10.right = right;
    return _this10;
  }

  _createClass(BinOp, [{
    key: "toString",
    value: function toString() {
      return "".concat((0, _utils.maybeParen)(this, this.left), " ").concat(this.op, " ").concat((0, _utils.maybeParen)(this, this.right, true));
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        op: this.op.toJSON(),
        left: this.left.toJSON(),
        right: this.right.toJSON()
      };
    }
  }]);

  return BinOp;
}(Expression);

exports.BinOp = BinOp;
BinOp.attrs = ['left', 'op', 'right'];

var Constant = /*#__PURE__*/function (_Expression7) {
  _inherits(Constant, _Expression7);

  var _super8 = _createSuper(Constant);

  function Constant(value) {
    var _this11;

    _classCallCheck(this, Constant);

    _this11 = _super8.call(this);
    _this11.value = value;
    return _this11;
  }

  _createClass(Constant, [{
    key: "valueOf",
    value: function valueOf() {
      return this.value;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.value;
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.value.toString().toUpperCase();
    }
  }]);

  return Constant;
}(Expression);

exports.Constant = Constant;
Constant.attrs = ['value'];

var List = /*#__PURE__*/function (_Expression8) {
  _inherits(List, _Expression8);

  var _super9 = _createSuper(List);

  function List() {
    var _this12;

    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    _classCallCheck(this, List);

    _this12 = _super9.call(this);
    _this12.items = items;
    return _this12;
  }

  _createClass(List, [{
    key: "valueOf",
    value: function valueOf() {
      return this.items.map(function (item) {
        return item.valueOf();
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[".concat(this.items.join(', '), "]");
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.items.map(function (item) {
        return item.toJSON();
      });
    }
  }]);

  return List;
}(Expression);

exports.List = List;
List.attrs = ['items'];

var Identifier = /*#__PURE__*/function (_Expression9) {
  _inherits(Identifier, _Expression9);

  var _super10 = _createSuper(Identifier);

  function Identifier(id) {
    var _this13;

    _classCallCheck(this, Identifier);

    _this13 = _super10.call(this);
    _this13.id = id;
    return _this13;
  }

  _createClass(Identifier, [{
    key: "toString",
    value: function toString() {
      return this.id;
    }
  }]);

  return Identifier;
}(Expression);

exports.Identifier = Identifier;
Identifier.attrs = ['id'];

var Empty = /*#__PURE__*/function (_Expression10) {
  _inherits(Empty, _Expression10);

  var _super11 = _createSuper(Empty);

  function Empty() {
    _classCallCheck(this, Empty);

    return _super11.apply(this, arguments);
  }

  _createClass(Empty, [{
    key: "toString",
    value: // eslint-disable-next-line class-methods-use-this
    function toString() {
      return 'EMPTY';
    }
  }], [{
    key: "create",
    value: function create() {
      return new Empty();
    }
  }]);

  return Empty;
}(Expression);

exports.Empty = Empty;

var Null = /*#__PURE__*/function (_Expression11) {
  _inherits(Null, _Expression11);

  var _super12 = _createSuper(Null);

  function Null() {
    _classCallCheck(this, Null);

    return _super12.apply(this, arguments);
  }

  _createClass(Null, [{
    key: "toString",
    value: // eslint-disable-next-line class-methods-use-this
    function toString() {
      return 'NULL';
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "valueOf",
    value: function valueOf() {
      return null;
    } // eslint-disable-next-line class-methods-use-this

  }, {
    key: "toJSON",
    value: function toJSON() {
      return null;
    }
  }]);

  return Null;
}(Expression);

exports.Null = Null;

var Number = /*#__PURE__*/function (_Constant) {
  _inherits(Number, _Constant);

  var _super13 = _createSuper(Number);

  function Number() {
    _classCallCheck(this, Number);

    return _super13.apply(this, arguments);
  }

  return Number;
}(Constant);

exports.Number = Number;

var Bool = /*#__PURE__*/function (_Constant2) {
  _inherits(Bool, _Constant2);

  var _super14 = _createSuper(Bool);

  function Bool() {
    _classCallCheck(this, Bool);

    return _super14.apply(this, arguments);
  }

  return Bool;
}(Constant);

exports.Bool = Bool;

var String = /*#__PURE__*/function (_Constant3) {
  _inherits(String, _Constant3);

  var _super15 = _createSuper(String);

  function String() {
    _classCallCheck(this, String);

    return _super15.apply(this, arguments);
  }

  _createClass(String, [{
    key: "toRepr",
    value: function toRepr() {
      return "String(value=".concat(this.toString(), ")");
    }
  }, {
    key: "toString",
    value: function toString() {
      return "\"".concat(this.value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/'/g, "\\'").replace(/"/g, '\\"'), "\"");
    }
  }]);

  return String;
}(Constant);

exports.String = String;
Object.entries({
  Attribute: Attribute,
  Call: Call,
  BoolOp: BoolOp,
  UnaryOp: UnaryOp,
  BinOp: BinOp,
  List: List,
  Identifier: Identifier,
  Constant: Constant,
  Null: Null,
  Empty: Empty,
  Number: Number,
  String: String,
  Bool: Bool,
  Predicate: Predicate
}).forEach(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      t = _ref2[1];

  Node.register(name, t);
});